// Vendors
import React from 'react';

const ErrorNotice = (props) => {
  const { content } = props;

  return (
    <div className="notice notice--error" {...props}>
      {content}
    </div>
  );
};

export default ErrorNotice;
